/**
 * Determines whether a URL points to an SVG image.
 * Checks file extension and data URI MIME type.
 */
export default function isSvgUrl(url: string): boolean {
    if (!url) {
        return false;
    }

    // Check data URIs (e.g., "data:image/svg+xml;base64,...")
    if (url.startsWith('data:image/svg')) {
        return true;
    }

    // Check file extension, ignoring query strings and fragments
    try {
        const pathname = new URL(url, 'https://placeholder.invalid').pathname;
        return pathname.toLowerCase().endsWith('.svg');
    } catch {
        return false;
    }
}
